import { Study, User } from '@csp/csp-common-model';
import { ExternalIdKeyType } from '@csp/dmdp-api-common-dto';
import {
  CountryV1,
  OrgType,
  PracticeV1,
  createCountryV1Mock,
  createOrgV1Mock,
  createPracticeV1Mock,
} from '@csp/dmdp-api-org-dto';
import { createStudyV1Mock, StudyV1 } from '@csp/dmdp-api-study-dto';
import { createMockCreator } from '@csp/test-common-utils';
import { StudyFactory } from '../StudyFactory';

/**
 * @deprecated Use createStudyMock instead
 */
export const mockStudy = (
  countryV1?: Partial<CountryV1>,
  practiceV1?: Partial<PracticeV1>,
  studyV1?: Partial<StudyV1>,
): Study => {
  const studyOrg = createOrgV1Mock({
    orgId: '3',
    type: OrgType.TREE,
  });

  const country = createOrgV1Mock({
    orgId: '1',
    type: OrgType.COUNTRY,
    country: createCountryV1Mock(countryV1),
    branchParentIds: ['3'],
  });

  const practice = createOrgV1Mock({
    type: OrgType.PRACTICE,
    orgId: '2',
    practice: createPracticeV1Mock(practiceV1),
    branchParentIds: ['1'],
    externalIds: [
      {
        key: ExternalIdKeyType.CTMS_SITE_ID,
        value: '0SI00000001GL29',
      },
    ],
  });

  const study = createStudyV1Mock(studyV1);

  return StudyFactory.fromStudyV1('tenant1', studyOrg, [country, practice], study, {} as User);
};

export const createStudyMock = createMockCreator(mockStudy());
